import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DefaultLayout from "./components/Layout/DefaultLayout";
import Loader from "./common/Loader";
import { Toast } from "./common/Toast";
import AppRoutes from "./routes/index.js";

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  useEffect(() => {
    const timeout = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Toast />
      {loading ? (
        <Loader />
      ) : isLoginPage ? (
        <AppRoutes />
      ) : (
        <DefaultLayout>
          <AppRoutes />
        </DefaultLayout>
      )}
    </>
  );
}

export default App;
